import { nextTick, ref } from 'vue';
import raf from 'raf';

const transitions = {
  transition: 'transitionend',
  WebkitTransition: 'webkitTransitionEnd',
  MozTransition: 'transitionend',
  OTransition: 'oTransitionEnd otransitionend',
};

let transitionEvent;
if (typeof window !== 'undefined') {
  const { style } = document.createElement('div');
  const keys = Object.keys(transitions);
  for (let i = 0, key = keys[i]; i < keys.length; i += 1, key = keys[i]) {
    if (key in style) {
      transitionEvent = transitions[key];
      break;
    }
  }
}

const onTransitionEnd = (element, callback, fallback) => {
  element.addEventListener(transitionEvent, callback);
  let removed = false;
  const removeListener = () => {
    if (removed) return;
    element.removeEventListener(transitionEvent, callback);
    removed = true;
  };
  const timeout = setTimeout(callback, fallback + 16);
  return () => {
    removeListener();
    clearTimeout(timeout);
  };
};

const reflow = (el) => el.offsetParent;

const animationDuration = 150;

export default function useFilters({ lastLi, li7, ul }) {
  const moreShown = ref(false);
  const unsubscribe = ref(null);
  const collapsing = ref(false);
  const height = ref(null);
  const overflow = ref(null);

  async function toggleShowMore() {
    moreShown.value = !moreShown.value;
    if (unsubscribe.value) unsubscribe.value();

    collapsing.value = true;

    height.value = `${ul.value.offsetHeight}px`;
    overflow.value = 'hidden';

    await nextTick();

    reflow(ul.value);
    const handle = raf(() => {
      const { offsetTop, offsetHeight } =
        !moreShown.value && li7.value ? li7.value[0] : lastLi.value[0];

      unsubscribe.value = onTransitionEnd(
        ul.value,
        async () => {
          unsubscribe.value();
          collapsing.value = false;
          unsubscribe.value = null;
          await nextTick();

          height.value = '';
          overflow.value = '';
        },
        animationDuration,
      );

      const showMoreHeight = `${offsetTop + offsetHeight}px`;
      height.value = showMoreHeight;
    });
    unsubscribe.value = () => raf.cancel(handle);
  }

  return {
    toggleShowMore,
    moreShown,
    collapsing,
    height,
    overflow,
  };
}
